import {
  InteractionHistoricTable,
  ShopHistoricGetBeautyOutput,
} from "@okeys/shared-utils"
import { useQuery } from "@tanstack/react-query"
import { customAxios } from "../utils/customAxios/customAxios"
import { getToken } from "../utils/functions/getToken"

// Query pour l'historique de la boutique (shop historic)
export const useShopHistoricQuery = () => {
  const { data, isPending, isError, isSuccess, refetch, isFetching } =
    useQuery<ShopHistoricGetBeautyOutput>({
      queryKey: ["shop-historic"],
      queryFn: async () => {
        const token = await getToken()

        const response = await customAxios.get("/shop-historic", {
          headers: {
            Authorization: token,
          },
        })
        return response.data.items || ([] as ShopHistoricGetBeautyOutput[])
      },
    })

  return {
    pendingShopHistoric: isPending,
    errorShopHistoric: isError,
    successShopHistoric: isSuccess,
    refetchShopHistoric: refetch,
    shopHistoric: data,
    fetchingShopHistoric: isFetching,
  }
}

// Query pour l'historique des prestataires (historic)
export const useInteractionHistoricQuery = () => {
  const { data, isPending, isError, isSuccess, refetch, isFetching } = useQuery<
    InteractionHistoricTable[]
  >({
    queryKey: ["interaction-historic"],
    queryFn: async () => {
      const token = await getToken()

      const response = await customAxios.get("/interaction-historic", {
        headers: {
          Authorization: token,
        },
      })
      return response.data?.items || []
    },
  })

  return {
    pendingInteractionHistoric: isPending,
    errorInteractionHistoric: isError,
    successInteractionHistoric: isSuccess,
    refetchInteractionHistoric: refetch,
    interactionHistoric: data,
    fetchingInteractionHistoric: isFetching,
  }
}

// Ancienne query pour la compatibilité (utilise shop historic par défaut)
export const useHistoricQuery = useShopHistoricQuery
